module.exports = __webpack_public_path__ + "images/rocket_launch.jpg";